import $ from 'jquery';
import 'bootstrap';
import './bootstrapSwitch';

window.$ = $;

const labels = {
  html: 'HTML and CSS',
  httpheaders: 'HTTP',
  media: 'Media',
  sitemaps: 'Sitemaps',
};

let testId;

function msg_renderer(msg) {
  return `<li class="${msg.myclass}">
    <div class="title"><i class="${msg.icon}"></i> ${msg.title}</div>
    <div>${msg.message}</div>
    ${msg.ref ? msg.ref.map(ref => `<cite>Reference: <a href="${ref}" class="text-success">${ref}</a></cite>`) : ``}
    <div>
      ${msg.level && msg.level > 0 || msg.level === 0 ? `<span class="badge"><i class="fa fa-tachometer"></i> Rating ${msg.level}%</span>` : ``}
      ${msg.level && msg.level > 0 || msg.level === 0 ? `<span class="badge" title="The weight of this evaluation is ${msg.weight}"><i class="fa fa-signal"></i> Significance: ${stars(msg.weight)}</span>` : ``}
      ${msg.facets.map(facet => `<span class="label">${facet.replace("_", " ")}</span>`)}
    </div>
  </li>`;
}

const summary_template = `<div class="row"><div class="col-md-12">
<ul class="nav nav-tabs" id="tabs">
  <li class="tab active"><a href="#summary"><i class="fa fa-tachometer"></i> Summary</a></li>
</ul>
<div class="tab-content" id="tabs-content">
  <div class="tab-pane active" id="summary">
    <div class="row">
      <div class="col-md-2">
        <h3 class="rating_label text-center">Overall Rating</h3>
        <div class="rating text-center"><i class="fa fa-cog fa-spin fa-fw"></i></div>
        <a class="btn one-page-download" id="download-html" style="display: none;">
          <i class="fa fa-floppy-o"></i> One page printable HTML</a><br />
        <a class="btn one-page-download" id="download-earl" style="display: none;">
          <i class="fa fa-file"></i> EARL XML results</a>
      </div>
      <div class="col-md-3">
        <h3>Results</h3>
        <table class="table table-important">
          <tr><th>Web Archivability Facet</th>
            <th class="text-right">Rating</th>
          </tr>
          <tr><td>Accessibility</td>
            <td class="value Accessibility"><i class="fa fa-cog fa-spin fa-fw"></i></td>
          </tr>
          <tr><td>Cohesion</td>
            <td class="value Cohesion"><i class="fa fa-cog fa-spin fa-fw"></i></td>
          </tr>
          <tr><td>Metadata</td>
            <td class="value Metadata"><i class="fa fa-cog fa-spin fa-fw"></i></td>
          </tr>
          <tr><td>Standards Compliance</td>
            <td class="value Standards-Compliance"><i class="fa fa-cog fa-spin fa-fw"></i></td>
          </tr>
        </table>
      </div>
      <div class="col-md-7">
        <div style="margin-right: 6px;">
          <h3>About the method</h3>
          <p class="text-muted">Web archivability can be measured from several perspectives. Here, we have called
          these perspectives <i>Archivability Facets</i>. Their selection and calculation is based on
          information gathered from the target website combined with an evaluation of the website's compliance
          with recognised practices in digital curation (e.g. using adopted standards, validating formats, and
          assigning metadata). For more information, pleace check the following publications:</p>
          <p class="text-muted">Banos V., Manolopoulos Y., Web Content Management Systems Archivability,
            ADBIS 2015, <a href="http://dev.archiveready.com/bibtex-wcms.txt">BIB</a>.</p>
          <p class="text-muted">Banos V., Manolopoulos Y.: A quantitative approach to evaluate Website Archivability using the CLEAR+ method,
          International Journal on Digital Libraries, 2015, <a href="http://link.springer.com/article/10.1007/s00799-015-0144-4?sa_campaign=email/event/articleAuthor/onlineFirst">Springer Link</a> &middot; <a href="/bibtex-springer.txt" title="Insert in BibTeX">BIB</a>.</p>
          <p class="text-muted">Banos V., Kim Y., Ross S., Manolopoulos Y.: CLEAR: a credible method to evaluate website archivability,
          iPRES 2013, <a href="http://purl.pt/24107/1/iPres2013_PDF/CLEAR%20a%20credible%20method%20to%20evaluate%20website%20archivability.pdf" title="Download the full paper in PDF format">PDF</a> &middot; <a href="/bibtex.txt" title="Insert in BibTeX">BIB</a>.</p>
        </div>
      </div>
    </div>
  </div>
</div>
</div></div>`; // end row and container

function stars(weight) {
  switch (weight) {
  case 'LOW':
    return '<i class="fa fa-star"></i>';
  case 'HIGH':
    return '<i class="fa fa-star"></i>'.repeat(3);
  default: // includes MEDIUM
     return '<i class="fa fa-star"></i>'.repeat(2);
  }
}

/* render tab */
function render_output(data, prefix) {
  const counters = data.messages.reduce(function (cnt, msg) {
    cnt[msg.myclass] += 1;
    return cnt;
  }, { ok: 0, warning: 0, error: 0, info: 0 });
  data.messages = data.messages.map(function (msg) {
    msg.stars = stars(msg.weight);
    return msg;
  });

  $(`#${prefix}`).append(
    $('<ol>').html(data.messages.reduce((out, msg) => { return out + msg_renderer(msg); }, ""))
  );
  $(`a.${prefix} > i`).attr('class', 'fa fa-check');
  $(`a.${prefix}`).append($('<span>').addClass('badge').html(data.messages.length));
  const $msg = $('<span>').html('Evaluation complete!');
  if (counters.ok > 0) {
    $msg.append(
      $('<i class="fa fa-check-circle-o">'),
      $('<span>').addClass('ok').html(`${counters.ok} Correct`),
    );
  }
  if (counters.warning > 0) {
    $msg.append(
      $('<i class="fa fa-exclamation-triangle">'),
      $('<span class="warning">').html(`${counters.warning} Warnings`),
    );
  }
  if (counters.error > 0) {
    $msg.append(
      $('<i class="fa fa-minus-circle">'),
      $('<span class="error">').html(`${counters.error} Errors`),
    );
  }
  if (counters.info > 0) {
    $msg.append(
      $('<i class="fa fa-info-circle">'),
      $('<span class="info">').html(`${counters.info} Information`),
    );
  }
  $(`div.loading.${prefix}`).remove();
  $('.rating').html(`${data.test.website_archivability}%`);
  $('.Accessibility').html(`${data.test.Accessibility}%`);
  $('.Cohesion').html(`${data.test.Cohesion}%`);
  $('.Metadata').html(`${data.test.Metadata}%`);
  $('.Standards-Compliance').html(`${data.test.Standards_Compliance}%`);
}
function createCallback(key) {
  return data => render_output(data, key);
}
function render_one_page_output(data, key) {
  $('#html-one-page-results').append(
    $('<h3>').text(labels[key]),
    $('<ol>').html(data.messages.reduce((out, msg) => { return out + msg_renderer(msg); }, ""))
  );
}

function fixUrl() {
  const urlElement = $('#url');
  let urlValue = urlElement.val();
  if (!/^(https?|ftp):\/\//i.test(urlValue)) {
    urlValue = `http://${urlValue}`;
  }
  urlElement.val(urlValue);
}

function check_webpage(url, test_id) {
  $('#all-results-here').append(summary_template);
  const $ul = $('#tabs');
  for (const key in labels) {
    $ul.append(
      $('<li>').append(
        $('<a>').attr('href', `#${key}`).attr('class', key).append(
          $('<i class="fa fa-cog fa-spin fa-fw">'),
          labels[key],
        ),
      ),
    );
    $('#tabs-content').append(
      $('<div>').attr('id', key).addClass('tab-pane').append(
        $('<div>').addClass(`loading ${key}`).append(
          $('<i>').addClass('fa fa-cog fa-spin fa-fw'),
          $('<span>').html('Processing, please wait...'),
          $('<div>').addClass('progress progress-striped active').append(
            $('<div>').addClass('bar bar-success').css('width', '50%'),
          ),
        ),
      ),
    );
    $.getJSON(`/check-method/${key}/${test_id}`, { url: url }, createCallback(key));
  }
  $('#tabs a').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
  });
  $('#download-html').attr('href', `/download-results/html/${test_id}`);
  $('#download-earl').attr('href', `/download-results/earl/${test_id}`);
}

function createOnePageCallback(key) {
  return data => render_one_page_output(data, key);
}

$(document).ready(() => {
  // if html-one-page-results
  if ($('#html-open-page-results').get(0)) {
    testId = $('#test-id').html();
    for (const key in labels) {
      $.getJSON(`/check-method/${testId}`, createOnePageCallback(key));
    }
  }
  // if check page and test id available, run check JS
  if ($('#test-id').length && $('#url').length) {
    testId = $('#test-id').val();
    check_webpage($('#url').val(), testId);
  }
  // if Enter or check button are pressed, submit form
  const run_process = () => {
    fixUrl();
    $('#checkForm').submit();
  };
  $('#checknow').click(run_process);
  $('#url').keypress((ev) => {
    if (ev.keyCode === 13) {
      run_process();
    }
  });
  $('#toggle-messages').on('switch-change', (e, data) => {
    if (data.value) {
      $('li.ok, li.info').show();
    } else {
      $('li.ok, li.info').hide();
    }
  });
});
// when all ajax is finished, show the total results
$(document).ajaxStop(() => $('.one-page-download').show());
